<script lang="ts">
  import { type Size, SIZE_MAP } from './icon';
  interface Props {
    size?: Size;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  }
  let { size = $bindable('md'), ...rest }: Props = $props();
  let computedSize = $derived(SIZE_MAP[size] as Size);
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width={computedSize}
  height={computedSize}
  viewBox="0 0 24 24"
  {...rest}>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.47 1.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06l-2.47-2.47v10.987a.75.75 0 0 1-1.5 0V4.06L8.78 6.53a.75.75 0 0 1-1.06-1.06l3.75-3.75ZM6.375 9.75a1.125 1.125 0 0 0-1.125 1.125v9A1.125 1.125 0 0 0 6.375 21h11.25a1.125 1.125 0 0 0 1.125-1.125v-9a1.125 1.125 0 0 0-1.125-1.125H15.75a.75.75 0 0 1 0-1.5h1.875a2.625 2.625 0 0 1 2.625 2.625v9a2.625 2.625 0 0 1-2.625 2.625H6.375a2.625 2.625 0 0 1-2.625-2.625v-9A2.625 2.625 0 0 1 6.375 8.25H8.25a.75.75 0 0 1 0 1.5H6.375Z"
      fill="#007CFF" />
  </g>
</svg>
